// extracted by mini-css-extract-plugin
export var label = "_hl-2";
export var slideContainer = "_hl-0";
export var slider = "_hl-1";